// extracted by mini-css-extract-plugin
export default {"sections":"CustomerUI_sections__c+F0j"};